/** 
*@author: satyamurthy.a
*@Description : 
**/
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { Input, Popconfirm, Tooltip ,Button} from 'antd';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import { API_SERVICEREQ } from '../../../../../commons/api';
import localStorage from '../../../../../utils/localStorage';
import translation from '../../../../../commons/translation';

import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  deleteById,
  getUsersList,
  getSRList,
  getDataSourceOfInspection
} from '../../../Utils/FormCalls';

const InspectionList = ({ translationCache, navigate }) => {
  const [dataSource, setDataSource] = useState([]);
  const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const config = {
    viewTypes: ['card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['InspectionId'],
    firstTitle: 'InspectionId',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/InspectionDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await _getDataSource(dayjs().format('YYYY-MM-DD'));
      await _getUserList();
    };
    fetchData();
  }, []);

  const _getUserList = async () => {
    const users = await getUsersList();
    setUserList(users);
  };

  const _getDataSource = async (date) => {
    const start = dayjs(date).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
    const end = dayjs(date).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
    const payload = {
      currentDate: date,
      startDate: start,
      endDate: end
    };
    const data = await getDataSourceOfInspection(payload);
    setDataSource(data);
  };

  const edit = (record) => {
    navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  const _deleteById = async (id) => {
    const siteId = localStorage.get('currentSite');
    const payload = {
      url: `${API_SERVICEREQ.DELETE}?Id=${id}&SiteId=${siteId}`,
      method: 'POST'
    };
    await deleteById(payload);
    const data = await getSRList('both');
    setDataSource(data);
  };

  const getColumnSearchProps = (dataIndex, columnName) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(translationCache, `Search ${columnName}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const columns = [
    {
      title: translation(translationCache, 'Inspection Id'),
      dataIndex: 'InspectionId',
      key: 'InspectionId',
      ...getColumnSearchProps('InspectionId', 'Inspection Id'),
      filter: true
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description', 'Description')
    },
    {
      title: translation(translationCache, 'Scheduler Name'),
      dataIndex: 'SchedulerName',
      key: 'SchedulerName',
      filter: true,
      ...getColumnSearchProps('SchedulerName', 'Scheduler Name')
    },
    {
      title: translation(translationCache, constant.inspectionCreationTime),
      dataIndex: 'InspectionCreationTime',
      key: 'InspectionCreationTime',
      filter: true,
      render: (text) => <div>{dayjs.utc(text).local().format('YYYY-MM-DD HH:mm:ss')}</div>
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            disabled={record.Status === 'Inactive'}
            style={{ marginRight: '5px' }}
            onClick={() => edit(record)}
          >
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(translationCache, 'Are you sure that you want to delete the Inspection')}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.Id)}
            okText={translation(translationCache, constant.yes)}
            cancelText={translation(translationCache, constant.no)}
          >
            <Button>
              <Tooltip title={translation(translationCache, 'Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <>
      <ListView
        columns={columns}
        dataSource={dataSource}
        userList={userList}
        config={config}
        delete={_deleteById}
        selection={{ widget: 'date-picker' }}
        _getDataSource={(e) => _getDataSource(e)}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile,
});

export default connect(mapStateToProps)(InspectionList);